import App from "./App";
import WebApp from "@twa-dev/sdk";
import ReactGA from 'react-ga4';
import {useEffect} from "react";

const InitApp = () => {
    WebApp.expand();
    ReactGA.initialize('G-Z686G8BTQK', {
        gaOptions: {
            userId: WebApp.initDataUnsafe.user?.id ?? undefined
        }
    });
    ReactGA.event("app_opened", {
        user_id: WebApp.initDataUnsafe.user?.id ?? null,
        start_param: WebApp.initDataUnsafe.start_param ?? "bot",
    });

    useEffect(() => {
        // Some versions of Telegram don't need the classes above.
        if (['macos', 'tdesktop', 'weba', 'web', 'webk'].includes(WebApp.platform)) {
            return;
        }

        document.body.classList.add('sticky-body');
        document.getElementById('wrap')?.classList.add('sticky-wrap');
        document.getElementById('content')?.classList.add('sticky-content');
    })

    return (
        <div id="wrap">
            <div id="content" className={"mr-3 ml-3"}>
                <App/>
            </div>
        </div>
)
}

export default InitApp;